module.exports = __webpack_public_path__ + "img/about_h.12c154f6.jpg";